import { useFiltersContext } from "providers/FiltersProvider";

const useFilters = () => {
  return useFiltersContext();
};

export default useFilters;
